import React, { Component } from 'react'
import { connect } from 'react-redux'
import { LinkedInput, LinkedInputGroup } from 'components/basic'
import { Installation } from 'config'
import http from 'API/http'
import { notify } from 'helpers'

class LoginPage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      newPassword: {
        a: '',
        b: ''
      },
      errorMsg: null,
      error: false,
      subpage: 'LOGIN',
      resetUser: '',
      resetString: '',
      loading: false,
      loggingIn: false
    }
    window.addEventListener('keydown', e => e.keyCode === 13 && this.state.subpage === 'LOGIN' && !window.localStorage.getItem('flow_basic_auth') && this.handleSubmit())
  }
  async componentDidMount () {
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: 'Login'
    })
    this.props.dispatch({
      type: 'SET_LANGUAGE',
      payload: 'EN'
    })
    this.setSubpage()

    var user = window.localStorage.getItem('flow_basic_auth')
    if (!user) return
    user = JSON.parse(user)
    this.setState({
      username: user.username,
      password: user.password
    }, () => {
      setTimeout(() => {
        this.handleSubmit()
      }, 0)
    })
  }
  componentWillReceiveProps (nextProps) {
    if (this.props.siteReducer.access === nextProps.siteReducer.access) return
  }
  async handleSubmit () {
    this.setState({loggingIn: true})
    var err, res
    [err, res] = await http.get('2.4/password/login', {}, {
      username: this.state.username,
      password: this.state.password
    })
    if (err) return this.setState({error: true, loggingIn: false})

    this.props.dispatch({
      type: 'SET_BASIC_AUTH',
      payload: {
        username: this.state.username,
        password: this.state.password
      }
    })
    this.props.dispatch({
      type: 'SET_LOGIN',
      payload: {
        user: res.data,
        token: ''
      }
    })
    window.localStorage.setItem('flow_basic_auth', JSON.stringify({
      username: this.state.username,
      password: this.state.password
    }))
    if (window.location.hash.indexOf('login') !== -1) {
      window.location.hash = '/flow/dashboard'
    }
  }
  async resetPassword () {
    this.setState({loading: true})
    var err, res
    [err, res] = await http.post('2.4/password/reset', {
      emailAddress: this.state.emailAddress
    })
    if (err) return notify.alert('', res.cause, 'error')
    notify.alert('A password recovery email will be sent if the account exists.', '', 'success')
    this.setState({loading: false})
  }
  async setPassword () {
    var hash = window.location.hash.split('/')
    var resetString = hash[hash.length - 1]
    if (resetString.length === 0) return notify.warn('No reset ID in URL')

    if (this.state.newPassword.a.length < 8) return this.setState({error: true, errorMsg: 'Your password has to be atleast 8 characters in length'})
    if (this.state.newPassword.a !== this.state.newPassword.b) return this.setState({error: true, errorMsg: 'Your passwords do not match'})
    var valid = await new Promise((resolve, reject) => {
      this.form.check(resolve)
    })
    if (!valid) return this.setState({error: true, errorMsg: 'Your password does not meet the requirements'})

    var [err, res] = await http.post('2.4/password/reset/' + resetString, {
      password: this.state.newPassword.a
    })

    if (err) return notify.alert('', res.cause, 'error')
    notify.alert('Your password has been updated', '', 'success')
    window.location.hash = '/login'
    this.setSubpage('LOGIN')
    this.setState({ username: this.state.resetUser })
  }
  setSubpage (page) {
    if (page) return this.setState({subpage: page, error: false})
    if (window.location.hash.indexOf('set') !== -1) return this.setState({subpage: 'SET', error: false})
    if (window.location.hash.indexOf('request') !== -1) return this.setState({subpage: 'REQUEST', error: false})
    this.setState({subpage: 'LOGIN'})
  }
  render () {
    return (
      <div className='site-wrapper sidebar-active'>
        <div className='login-page'>
          {this.state.subpage === 'LOGIN' &&
            <div className='login-box'>
              <img src='/static/maintrac.svg' className='flow-login-logo' width='120' />
              <div className={'alert alert-danger ' + (!this.state.error ? 'hidden' : '')}>
                Wrong username or password, please try again.
              </div>
              <div className='form-group'>
                <label>Email</label>
                <LinkedInput context={this} path='username' />
              </div>
              <div className='form-group'>
                <label>Password</label>
                <LinkedInput type='password' context={this} path='password' />
              </div>
              <div className='row'>
                <div className='col-xs-6'>
                  {Installation.enable.passwordRecovery && <a style={{'fontWeight': 'bold', 'color': '#555', 'opacity': '0.7'}} href='/#/password/request' onClick={e => {
                    this.setSubpage('REQUEST')
                  }}>Forgot your password?</a>}
                </div>
                <div className='col-xs-6'>
                  <a disabled={(this.state.loggingIn)} className='btn btn-primary pull-right' onClick={e => this.handleSubmit()}>{(this.state.loggingIn ? <span><i hidden={!this.state.loggingIn} className='fa fa-spin fa-spinner' /> Logging in</span> : 'Login')}</a>
                </div>
              </div>
              <span className='maintrac-login-logo'>{Installation.systemName}</span>
            </div>
          }
          {this.state.subpage === 'SET' &&
            <div className='login-box'>
              <LinkedInputGroup ref={(form) => { this.form = form }}>
                <div className='row'>
                  <img src='/static/maintrac.svg' className='flow-login-logo' width='120' />
                  <div className={'alert alert-danger ' + (!this.state.error ? 'hidden' : '')}>
                    {this.state.errorMsg}
                  </div>
                  <div className='col-md-12'>
                    <label>Password <small><b>Minimum of 8 characters in length (A-ö, 0-9, !"#€%&/\()=?`")</b></small></label>
                    <LinkedInput validate={/^((?!.*[\s])(?=.*[A-Öa-ö0-9]).{8,100})/} type='password' context={this} path='newPassword.a' />
                  </div>
                  <div className='col-md-12'>
                    <label>Repeat Password</label>
                    <LinkedInput type='password' validate={/^((?!.*[\s])(?=.*[A-Öa-ö0-9]).{8,100})/} context={this} path='newPassword.b' />
                  </div>
                  <div className='col-md-12 mt-20'>
                    <a className='btn btn-primary pull-right' onClick={e => this.setPassword()}>CHANGE PASSWORD</a>
                  </div>
                </div>
                <span className='maintrac-login-logo'>{Installation.systemName}</span>
              </LinkedInputGroup>
            </div>
          }
          {this.state.subpage === 'REQUEST' &&
          <div className='login-box'>
            <img src='/static/maintrac.svg' className='flow-login-logo' width='120' />
            <div className={'alert alert-danger ' + (!this.state.error ? 'hidden' : '')}>
              Wrong email or password, please try again.
            </div>
            <div className='form-group'>
              <label>
                Email address
              </label>
              <LinkedInput context={this} path='emailAddress' />
            </div>
            <div className='row'>
              <div className='col-xs-6'>
                <a href='/#/' onClick={e => {
                  this.setSubpage('LOGIN')
                }}>Back to login</a>
              </div>
              <div className='col-xs-6'>
                <a className='btn btn-primary pull-right' onClick={e => this.resetPassword()}>{!this.state.loading ? 'REQUEST NEW PASSWORD' : <i className='fa fa-spin fa-spinner' />}</a>
              </div>
            </div>
            <span className='maintrac-login-logo'>{Installation.systemName}</span>
          </div>
        }
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
LoginPage = connect(state => state)(LoginPage)
export default LoginPage



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/core/login.js